module.exports = __webpack_public_path__ + "img/Weapon_50.ac6e8f81.png";